module.exports = __webpack_public_path__ + "html/landing-new-bottom_80a6070e9da934b8bdf8eecbfbd1eb2c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/landing-new-bottom.html
// module id = gkLk
// module chunks = 151